export default __webpack_public_path__ + "static/media/shopping-cart.89aaba89.svg";